export default "__VITE_ASSET__Av4BcjQ7__"